import { render, staticRenderFns } from "./ClinicianRespondentFormWrapper.vue?vue&type=template&id=081c4a72"
import script from "./ClinicianRespondentFormWrapper.vue?vue&type=script&lang=js"
export * from "./ClinicianRespondentFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports